import { render } from "./SkeletonDailyScene.vue?vue&type=template&id=c618e4ce"
import script from "./SkeletonDailyScene.vue?vue&type=script&lang=js"
export * from "./SkeletonDailyScene.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__